import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { Content_Title } from '../../shared/constants';
import { useLazyQuery } from '@apollo/client';
import { SimpleBackdrop } from '../SimpleBackdropComponent/SimpleBackdrop';
import { FETCH_CONSENT } from '../../services/userQueries/ConsentService';
import { useSnackbar } from 'notistack';
import { Link } from '@mui/material';
import { TERM_CONDITIONS } from '../../shared/Strings';

const Content_text = {
  maxHeight: '50vh',
  borderRadius: '5px',
  backgroundColor: '#e4e4e4',
  overflow: 'auto',
  padding: '18px 9px 18px 9px',
  textAlign: 'justify',
};

const termsLink = {
  padding: '6px 4px',
  fontWeight: 550,
  fontSize: '14px',
  lineHeight: '24px',
  textTransform: 'none',
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
  '&:hover': {
    background: 'transparent',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
  },
};

export default function TermsAndCondition(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [fetchTermsAndConditions, { data, loading }] = useLazyQuery(
    props?.query || FETCH_CONSENT,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(TERM_CONDITIONS.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
          variant: 'error',
        });
      },
    }
  );

  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');
  const [variables, setVariables] = React.useState(null);

  const handleClickOpen = scrollType => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (open && variables) {
      if (props?.query) {
        fetchTermsAndConditions({
          variables: variables,
        });
      } else {
        fetchTermsAndConditions({
          variables: variables,
        });
      }
    }
  }, [open, fetchTermsAndConditions, props, variables]);

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      {props?.scheduleVisit ? (
        <Link sx={{ cursor: 'pointer' }} onClick={handleClickOpen('paper')}>
          {props?.scheduleVisit || TERM_CONDITIONS.VIEW_TERM}
        </Link>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            sx={termsLink}
            onClick={() => {
              setVariables({
                functionalityType: 'SIGN_UP',
                consentType: 'TERMS_AND_CONDITIONS',
              });
              handleClickOpen('paper');
            }}>
            {TERM_CONDITIONS.TERMS_CONDITIONS}
          </Button>
          <Box
            sx={{
              mt: 1,
            }}>
            <Typography variant="body2">&</Typography>
          </Box>

          <Button
            sx={termsLink}
            onClick={() => {
              setVariables({
                functionalityType: 'SIGN_UP',
                consentType: 'PRIVACY_POLICY',
              });
              handleClickOpen('paper');
            }}>
            {TERM_CONDITIONS.PRIVACY_POLICY}
          </Button>
        </Box>
      )}
      <Box
        sx={{
          width: '420px',
          position: 'fixed',
          mt: '50%',
          ml: '0',
          transform: 'translate(0, -50%)',
          overflowY: 'auto',
        }}>
        <Dialog
          open={open}
          onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description">
          <DialogTitle
            align="center"
            boxShadow="0px 2px 6px 0px rgba(0, 0, 0, 0.15)">
            {variables?.consentType === 'TERMS_AND_CONDITIONS'
              ? Content_Title.Title
              : Content_Title.PrivacyPolicy}

            <Typography sx={{ mt: 2, textAlign: 'justify' }}>
              {variables?.consentType === 'TERMS_AND_CONDITIONS'
                ? Content_Title.Description
                : Content_Title.PrivacyPolicyDescription}
            </Typography>
          </DialogTitle>
          <DialogContent
            sx={{
              margin: '0 13px 31px 13px',
            }}>
            <DialogContentText
              sx={Content_text}
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              tabIndex={-1}>
              <div
                dangerouslySetInnerHTML={{
                  __html: props?.query
                    ? data?.getAllPublicConsents?.htmlContent
                    : data?.noAuthgetAllPublicConsents?.htmlContent,
                }}></div>
            </DialogContentText>
          </DialogContent>
          {/*<div> {parser().parse(rawHTML)}</div>*/}
          <DialogActions>
            <Button
              type="submit"
              //size={'large'}
              variant="contained"
              //fullWidth
              sx={{ mt: 1, md: 2, mx: 'auto', minWidth: '240px' }}
              onClick={handleClose}>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      <SimpleBackdrop open={loading} />
    </div>
  );
}
